import React, { FC } from 'react';
import { Modal, ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { T_KEY } from '../../../utils';

interface SaveChangesModalProps {
    isSaveChangesModalOpen: boolean;
    setIsSaveChangesModalOpen: (isOpen: boolean) => void;
    closeDrawer: () => void;
}

const SaveChangesModal: FC<SaveChangesModalProps> = ({
    isSaveChangesModalOpen,
    setIsSaveChangesModalOpen,
    closeDrawer,
}) => (
    <Modal isOpen={isSaveChangesModalOpen} onClose={() => setIsSaveChangesModalOpen(false)}>
        <ModalContent size="sm" closeOnOverlayClick closeOnEscapeKey={false}>
            <ModalHeader>
                <I18n k={`${T_KEY}.save_changes_modal.title`} />
                <ModalCloseBtn />
            </ModalHeader>
            <ModalBody>
                <I18n k={`${T_KEY}.save_changes_modal.description`} />
            </ModalBody>
            <ModalFooter>
                <Button intent="secondary" variant="ghost" onClick={() => setIsSaveChangesModalOpen(false)}>
                    <I18n k={`${T_KEY}.save_changes_modal.cancel`} />
                </Button>
                <Button intent="primary" onClick={closeDrawer}>
                    <I18n k={`${T_KEY}.save_changes_modal.discard`} />
                </Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
);

export default SaveChangesModal;
